
export default {
  inheritAttrs: false,
  props: {
    address: {
      type: String,
      default: null
    },
    geoAddress: {
      type: String,
      default: null
    },
    longitude: {
      type: Number,
      default: null
    },
    latitude: {
      type: Number,
      default: null
    },
    icon: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    data() {
      return Object.keys(this.$props).reduce((data, key) => ({
        ...data,
        [key]: this[key] || this.$contact[key]
      }), {})
    },
    attrs() {
      const { address, geoAddress, longitude, latitude } = this.data
      const link = {}

      if (geoAddress) {
        link.href = this.addressLink(geoAddress)
      } else if ( longitude && latitude ) {
        link.href = this.geoLink(latitude, longitude)
      } else if (address) {
        link.href = this.addressLink(address)
      }

      return link
    }
  },
  methods: {
    onClick() {
      this.$tracker.trackEvent('view_location', {
        category: 'contact',
        label: 'location'
      })
    },
    geoLink(lat, lon) {
      return `https://www.google.com/maps/place/${lat},${lon}`
    },
    addressLink(address) {
      const search = address.replace(/\s/g, '+')
      return `https://www.google.com/maps/search/${search}`
    }
  }
}
